import {mapState} from "vuex";

export default {
    data(){
        return {
            selectedAppointment: null
        }
    },
    methods:{

        showClientHistory(clientId) {
            const vm = this
            vm.$refs.clientAttentionHistory.show(clientId)
        },
        onClientUpdated() {
            var vm = this
            vm.$refs.clientEditForm.hide()
        },
        onPaymentUpdated() {
            var vm = this
            vm.$refs.paymentEditForm.hide()
        },
        onClientEditClick(client) {
            var vm = this
            vm.$refs.clientEditForm.show(client)

        },
        onPaymentEditClick(appointment) {
            var vm = this
            vm.$refs.paymentEditForm.show(appointment)

        },
        appointmentDetails(appointment) {
            var vm = this
            vm.selectedAppointment = appointment
            vm.$refs.detailsDialog.show()
        },
        arrive(appointment) {
            var vm = this
            vm.$refs.clientArrive.show(appointment)
        },
    },
    computed: {
        ...mapState(['currentProvider']),
        requiredFields(){
            var vm = this
            if(!vm.currentProvider || !vm.currentProvider.settings || !vm.currentProvider.settings.client_form_fields) return []
            return vm.currentProvider.settings.client_form_fields
                .filter(field => field.pivot.required)
                .map(field => field.name)
        },
        requestedFields(){
            var vm = this
            if(!vm.currentProvider || !vm.currentProvider.settings || !vm.currentProvider.settings.client_form_fields) return []
            return vm.currentProvider.settings.client_form_fields
                .map(field => field.name)
        }
    },
}
